import { computed } from '@vue/composition-api';
import Cookies from 'js-cookie';

// eslint-disable-next-line import/no-cycle
import store from '@/store';
import { LOGIN_COOKIE } from '@/environment';
import Client from '@/api/client';
import { actions } from '@/controller';
import { useClient } from '@/use';

export interface MPFCookie {
  url: string;
}

export const loggedIn = computed(() => store.state.client !== null);
export const user = computed(() => store.state.client?.user || null);

export function saveCookie(cookie: MPFCookie) {
  Cookies.set(LOGIN_COOKIE, JSON.stringify(cookie));
}

export function readCookie(): MPFCookie | undefined {
  const cookie = Cookies.get(LOGIN_COOKIE);

  if (cookie === undefined) { return cookie; }
  return JSON.parse(cookie) as MPFCookie;
}

// var delete_cookie = function(name: string) {
//   document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
// };

export async function logout() {
  const client = useClient();
  const isLogout = await client.logoutUser();
  if (isLogout) {
    actions.clearDataset();
    // Clear token refresh timeout, if it exists
    window.clearTimeout(store.state.client?.refreshTimeoutId);
    store.commit.setClient(null);
  }
}

export async function loginExisting() {
  const existingCookie = readCookie();
  if (!existingCookie) {
    return;
  }

  const { url } = existingCookie;
  try {
    // Try to create client with stored token
    // store.commit.setClient(new Client(url, token));
    store.commit.setClient(await Client.Create(url, true));
  } catch (e) {
    // Client creation failed, logout
    logout();
  }
}
